module.exports = __webpack_public_path__ + "img/prize-05.31d62d34.png";